export function resolveModalCustomerContext({
  routeCustomerId = null,
  dashboardCustomerId = null,
  customerDetails = null,
  customer = null,
} = {}) {
  const rawCustomerId = routeCustomerId ?? dashboardCustomerId ?? customer?.id ?? customerDetails?.id ?? null;
  const customerId = Number.isInteger(Number(rawCustomerId)) && Number(rawCustomerId) > 0 ? Number(rawCustomerId) : null;

  const teamIdValue = customerDetails?.team?.id
    ?? customerDetails?.team_id
    ?? customer?.team?.id
    ?? customer?.team_id
    ?? null;
  const teamId = Number.isInteger(Number(teamIdValue)) && Number(teamIdValue) > 0 ? Number(teamIdValue) : null;

  return { customerId, teamId };
}

export function resolvePendencyReplyContext({
  policyId = null,
  serviceId = null,
  agent = null,
  customerId = null,
  activeUserId = null,
  replyingUser = null,
} = {}) {
  const normalizedPolicyId = Number.isInteger(Number(policyId)) && Number(policyId) > 0 ? Number(policyId) : null;
  const normalizedServiceId = Number.isInteger(Number(serviceId)) && Number(serviceId) > 0 ? Number(serviceId) : null;
  const normalizedCustomerId = Number.isInteger(Number(customerId)) && Number(customerId) > 0 ? Number(customerId) : null;
  const isUserReplyingToPendency = Boolean(
    activeUserId && replyingUser && Number(activeUserId) === Number(replyingUser.id)
  );

  return {
    policyId: normalizedPolicyId,
    serviceId: normalizedServiceId,
    customerId: normalizedCustomerId,
    agent,
    isUserReplyingToPendency,
  };
}
